export default function() {

	new Swiper('.glam-banner-swiper', {
		slidesPerView: 1,
		navigation: {
			nextEl: '.glam-banner-swiper-nav.next',
			prevEl: '.glam-banner-swiper-nav.prev',
		},
		on: {
			init() {
				[...document.querySelectorAll(".glam-banner .video-banner")].map((el, index) => {
					let id = "glam-banner-video-" + index;
					el.setAttribute('id', id);
					let $videoWrapper = $(el).parent();
					let $playBtn = $(el).closest('.swiper-slide').find('.play-btn');
					console.log(el);
					let videoSrc = $playBtn.attr('video-url');
					let player = new videojs(id);

					player.src({type: 'video/youtube', src: videoSrc});
					player.on('play', function() {
						$videoWrapper.addClass('_playing');
					})
					player.on('pause', function() {
						$videoWrapper.removeClass('_playing');
					});

					player.on('ended', function() {
						$videoWrapper.removeClass('_playing');
					});

					$playBtn.click(function() {
						player.paused() && player.play();
					});

					$(el).closest('.swiper-slide')[0].player = player;
				});
				
			},
			slideChange() {
				let prevSlide = this.slides[this.previousIndex];
				prevSlide.player && prevSlide.player.pause();
			}
		}
	});

	let brandswipers = [];
	[...document.querySelectorAll(".brand-swiper")].map((el, index) => {
		let id = "brand-swiper-" + index;
		el.setAttribute('id', id);

		let swiper = new Swiper('#' + id, {
			slidesPerView: 5,
			slidesPerGroup: 1,
			spaceBetween: 40,
			navigation: {
				nextEl: ".brand-swiper-nav.next" ,
				prevEl: ".brand-swiper-nav.prev" ,
			},
			breakpoints: {
				767: {
					slidesPerView: 4
				},
				575: {
					slidesPerView: 3
				},
			}
		})
		brandswipers.push(swiper);
	})

	$('.brand-tablist a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
		brandswipers.map(swiper => {
			swiper.update();
		})
	})


}


// WEBPACK FOOTER //
// ./src/js/glam.js